import { render, staticRenderFns } from "./SpecialityChart.vue?vue&type=template&id=471bc034"
import script from "./SpecialityChart.vue?vue&type=script&lang=js"
export * from "./SpecialityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports